import React from 'react';

const rules = [
  { title: 'No False Pricing', desc: 'Submitting false or fraudulent pricing data is strictly prohibited.' },
  { title: 'No Trolling', desc: 'Intentionally adding misleading, troll, or disruptive content is not allowed.' },
  { title: 'No Spam', desc: 'Spamming users with advertisements, irrelevant content, or repeated messages is forbidden.' },
  { title: 'No Harassment or Abuse', desc: 'Harassment, hate speech, or abusive behavior will result in a ban.' },
  { title: 'No Ban Evasion', desc: 'Attempting to evade bans or circumvent moderation is a serious offense.' },
  { title: 'Follow All Applicable Laws', desc: 'Any conduct that violates our community guidelines or applicable laws is not allowed.' },
];

const CommunityRulesPage = () => (
  <div className="page-container legal-page" style={{ maxWidth: 700, margin: '0 auto', padding: '32px 0', textAlign: 'left' }}>
    <h1 style={{ color: '#3ff', marginBottom: 24, textAlign: 'left' }}>Community Rules</h1>
    <div style={{ marginBottom: 32 }}>
      {rules.map((rule, idx) => (
        <div key={rule.title} style={{ marginBottom: 18, padding: '12px 18px', background: '#181828', borderRadius: 8, boxShadow: '0 2px 8px #0002', textAlign: 'left' }}>
          <span style={{ color: '#0ff', fontWeight: 700, fontSize: 18 }}>{rule.title}:</span>
          <span style={{ marginLeft: 8, color: '#fff', fontSize: 16 }}>{rule.desc}</span>
        </div>
      ))}
    </div>
    <p style={{ fontStyle: 'italic', color: '#aaa', marginTop: 24, textAlign: 'left' }}>
      Violations may result in a ban and/or restriction of account deletion rights as described in our Terms of Service and Privacy Policy.
    </p>
  </div>
);

export default CommunityRulesPage; 